import PropTypes from 'prop-types';
import React from 'react';

import './Errors.css';

function Exception(_ref) {
  var displayCode = _ref.displayCode,
      exception = _ref.exception;

  if (!exception) {
    return null;
  }

  return React.createElement(
    'div',
    { className: 'Errors' },
    React.createElement('hr', null),
    React.createElement(
      'h3',
      null,
      'Got errors during submission'
    ),
    displayCode ? React.createElement(
      'pre',
      null,
      exception
    ) : React.createElement(
      'h4',
      null,
      exception
    )
  );
}

Exception.propTypes = process.env.NODE_ENV !== "production" ? {
  displayCode: PropTypes.bool,
  exception: PropTypes.string.isRequired
} : {};

export default Exception;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/Exception.js
// module id = 695
// module chunks = 0